import React from 'react';

export function DiplomaIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="currentColor"
      stroke="currentColor"
      {...props}
    >
      <path d="M33.402 38.49a4.22 4.22 0 01-2.543-.848V44l2.266-1.51a.5.5 0 01.554 0L35.947 44v-6.358a4.22 4.22 0 01-2.544.847z" />
      <path
        strokeWidth="4"
        d="M36.8 5H10.504C5 5 5 10.504 5 10.504s0 0 0 0v2.474a.5.5 0 00.5.5h10.508M36.8 5c-5.503 0-5.503 5.504-5.503 5.504s0 0 0 0v2.474a.5.5 0 01-.5.5h-14.79M36.8 5c5.504 0 5.504 5.504 5.504 5.504s0 0 0 0v26.908M16.008 13.478v23.434a.5.5 0 00.5.5h9.257m-5.08-16.303H37.64M30.86 37.642a4.24 4.24 0 115.087 0m-5.087 0a4.22 4.22 0 002.543.847 4.22 4.22 0 002.544-.847m-5.087 0V44l2.266-1.51a.5.5 0 01.554 0L35.947 44v-6.358m-15.261-8.479h6.782"
      />
    </svg>
  );
}
